import Card from "app/components/Card";
import { Skeleton } from "app/components/Skeleton";
import { TableHeader } from "app/components/Table/types";
import clsx from "clsx";
import React from "react";

interface Props {
  gridTemplate: string;
  minTableWidth: number;
   cols: TableHeader[]
}
const RowLoading: React.FC<Props> = ({ gridTemplate, minTableWidth ,cols}) => {
  return (
    <Card
      className={clsx(
        "grid items-center min-h-[36px] h-[36px] border-b border-gray-100 hover:bg-gray-200 group bg-white relative",
      )}
      style={{ gridTemplateColumns: gridTemplate, minWidth: minTableWidth }}
      role="row"
    >
      {cols.map((c)=>{
        return  <Skeleton key={c.id} className="h-[16px] w-[80%] " />
      })}
     
    </Card>
  );
};

export default RowLoading;
